import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'ngbd-yes-no-modal',
    template: `
    <div class="modal-header">
      <p class="modal-title"><fa-icon [icon]="['fas', 'question']" class="me-2" [fixedWidth]="true"></fa-icon>{{ title }}</p>
    </div>
    <div class="modal-body">
      <p class="text-justify ms-3 me-3 mb-0" style="font-size: 1.1em; line-height: 175%; white-space: pre-line;">{{ message }}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary btn-modal" (click)="yes()" autofocus>{{ 'button.ja' | translate }}</button>
      <button type="button" class="btn btn-danger btn-modal" data-dismiss="modal" (click)="no()">{{ 'button.nej' | translate }}</button>
    </div>`,
    styles: [`
    .modal-header {
      border-bottom: none;
      background-color: #2dbdb6;
      color: #fff
    }
    .modal-body, .modal-footer {
      background-color: #f3f3f3
    }
    .modal-footer {
      border-top: none
    }
  `],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NgbdYesNoModal {
  @Input() public title: string;
  @Input() public message: string;
  @Input() public buttonCallback: () => void;
  constructor(
    protected activeModal: NgbActiveModal) {
  }

  public yesFunction: () => any;

  public yes(): void {
    this.no();
    if (this.buttonCallback) this.buttonCallback();
  }

  public no(): void {
    this.activeModal.close();
  }
}
